import { useToast } from '~/eds/src/components/hooks/useToast';
import { SharedToastProps } from '~/eds/src/types/SharedToastProps';

import { CodedError, isCodedError } from './CodedError';

export const useErrorToast = () => {
  const { toast } = useToast();

  return {
    toast: (
      error: Error | CodedError,
      options?: Omit<SharedToastProps, 'message' | 'status'>,
    ) => {
      const { message } = error;

      toast({
        ...(options ?? {}),
        message: message,
        status: 'danger',
        title: isCodedError(error) ? error.cause.title : options?.title,
      });
    },
  };
};
